import React from "react";

import { useTranslation } from "react-i18next";
import { Box, Tooltip, Typography, CircularProgress } from "@mzc-pdc/ui";
import { alpha } from "@mui/material";
import theme from "@styles/theme";

export const AssetStatusArchiving = () => {
    const { t } = useTranslation();

    return (
        // className 을 붙이지 않는다 — containerType="archive" 로 만들던 `archive-status` 가
        // 레거시 cloudplex.core.css 의 `.archive-status > span { margin-left: 8px }` 에 걸려
        // 직계 span 인 CircularProgress 를 오른쪽으로 밀어냈다.
        <Box
            sx={{
                position: `absolute`,
                left: 0,
                top: 0,
                zIndex: 1,
                width: `100%`,
                height: `100%`,
                display: `flex`,
                flexDirection: `column`,
                alignItems: `center`,
                justifyContent: `center`,
                backgroundColor: alpha(theme.palette.secondary[50], 0.9),
            }}
        >
            <Tooltip
                open={true}
                color={"warning"}
                title={
                    <Typography variant={"body3_700"} textTransform={"uppercase"}>
                        {t(`common::label::Archiving...`, `Archiving...`)}
                    </Typography>
                }
            >
                <CircularProgress color="warning" size={16} />
            </Tooltip>
        </Box>
    );
};

export default React.memo(AssetStatusArchiving);
